import { put, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* myPostGoodUserListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('postId', payload.postId);
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/myPostGoodUserListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield put(loadingSet(false));
  if (res) {
    if (res.data.bool === true) {
      yield put({
        type: 'MY_POST_GOOD_USER_LIST_SET',
    		payload: {
          postId: action.payload.postId,
          list: res.data.list,
    			page: action.payload.page,
          isListNext: res.data.isListNext,
    		},
      });
      action.callback(res.data);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
}

const saga = [
  takeLatest('MY_POST_GOOD_USER_LIST_GET', myPostGoodUserListGet),
];

export default saga;
